// test2244
(2244 && 0);
